import type { GateStatus, ScalePanelStatus, SocketStatus } from '../types'

export const SOCKET_STATUS_LABELS: Record<SocketStatus, string> = {
  disconnected: 'Disconnected',
  connecting: 'Connecting...',
  connected: 'Connected',
  reconnecting: 'Reconnecting...',
}

export const SCALE_STATUS_LABELS: Record<ScalePanelStatus, string> = {
  idle: 'Waiting for truck',
  capturing: 'Capturing...',
  captured: 'Weight captured',
  error: 'Capture failed',
}

export const GATE_STATUS_LABELS: Record<GateStatus, string> = {
  open: 'OPEN',
  closed: 'CLOSED',
}

export const WEIGHBRIDGE_OPS_EVENTS = {
  CAPTURE_STARTED: 'capture_started',
  WEIGHT_CAPTURED: 'weight_captured',
  CAPTURE_ERROR: 'capture_error',
  GATE_CHANGED: 'gate_changed',
  ANPR_DETECTED: 'anpr_detected',
  DEVICE_STATUS: 'device_status',
} as const

export const WS_EVENTS = {
  ORDER_QUEUED: 'weighbridge:order_queued',
  ORDER_ENQUEUED: 'weighbridge:order_enqueued',
  ORDER_DETAILS: 'weighbridge:order_details',
  CAPTURE_STARTED: 'weighbridge:capture_started',
  WEIGHT_CAPTURED: 'weighbridge:weight_captured',
  WEIGHT_SAVED: 'weighbridge:weight_saved',
  CAPTURE_ERROR: 'weighbridge:capture_error',
  GATE_CHANGED: 'weighbridge:gate_changed',
  ANPR_DETECTED: 'weighbridge:anpr_detected',
  DEVICE_STATUS: 'weighbridge:device_status',
  SCALE_NOT_CLEAR: 'weighbridge:scale_not_clear',
  SCALE_CLEARED: 'weighbridge:scale_cleared',
  TRUCK_DEPARTED: 'weighbridge:truck_departed',
  STAGE_LOCK_CHANGED: 'weighbridge:stage_lock_changed',
  FLOW_BUSY: 'weighbridge:flow_busy',
  OVERWEIGHT_CONFIRM_REQUIRED: 'weighbridge:overweight_confirm_required',
  OVERWEIGHT_DECISION: 'weighbridge:overweight_decision',
  INTERNET_STATUS: 'weighbridge:internet_status',
} as const

export const WEIGHBRIDGE_CAPTURE_ENDPOINT = '/weighbridge/capture'
export const WEIGHBRIDGE_SUBMIT_ENDPOINT = '/weighbridge/submit'
export const WEIGHBRIDGE_ORDER_LOOKUP_ENDPOINT = '/weighbridge/order-lookup'

export const STAGE_LABELS = {
  first_weight: 'First Weight',
  second_weight: 'Second Weight',
} as const

/** Maximum number of events kept in in-memory session history. Older entries are dropped
 *  to prevent the eventHistory array from growing unboundedly and making memoized history
 *  selectors progressively slower with each WebSocket event. */
export const MAX_EVENT_HISTORY = 200

export const SAVE_ACK_TIMEOUT_MS = 60_000

export const INITIAL_SCALE_PANEL_STATE = {
  status: 'idle' as const,
  entryGateStatus: 'closed' as const,
  exitGateStatus: 'closed' as const,
  isLocked: false,
  lockedByOrder: undefined as string | undefined,
  captureInitiatedByUser: false,
  isSaving: false,
}
